module.exports = __webpack_public_path__ + "img/04_blast chiller_(white).7d2ba89a.svg";